import { useEffect, useCallback, useState } from 'react'
import * as R from 'ramda'
import effects from 'app/effects/effects'
import { useFetcher } from 'libs/fetcher'
import { findNumbers } from 'libphonenumber-js'

export const useCountryCode = () => {
  const [countryCode, setCountry] = useState('us') // Set US to be default country when cannot get geoInfo

  const fetchCountryCode = useCallback(effects.apis.getGeoInfo, [])

  const { values, isLoading: isGeoInfoLoading } = useFetcher(
    fetchCountryCode,
    {},
  )

  const geoInfo = values.data

  const getCountryCode = useCallback(
    R.when(
      R.compose(R.not, R.anyPass([R.isNil, R.isEmpty]), R.prop('country')),
      R.compose(setCountry, R.toLower, R.prop('country')),
    ),
    [],
  )

  useEffect(() => {
    getCountryCode(geoInfo)
  }, [geoInfo, getCountryCode])

  return { countryCode, isGeoInfoLoading }
}

export const parsedPhoneNumber = (inputPhoneNumber) => {
  const parsedPhoneNumber = findNumbers(inputPhoneNumber, 'US', {
    v2: true,
  })
  const phoneNumber = R.path(
    ['0', 'number', 'nationalNumber'],
    parsedPhoneNumber,
  )
  const countryCode = R.path(
    ['0', 'number', 'countryCallingCode'],
    parsedPhoneNumber,
  )

  const country = R.path(['0', 'number', 'country'], parsedPhoneNumber)
  if (R.any(R.isNil, [phoneNumber, countryCode])) return undefined
  return {
    phoneNumber,
    countryCode: '+' + countryCode,
    country,
  }
}

/**
 * getFullPhoneNumber :: Maybe String -> Maybe String -> Maybe String
 */
export const getFullPhoneNumber = (countryCode, phoneNumber) =>
  R.join('', R.filter(R.o(R.not, R.isNil), [countryCode, phoneNumber]))
